<template>

<div id="app">

  <div id="page-container">

    <div id="header-container">
      <div id="logo-container">
        <a :href="urls.portal">
          <img src="./assets/logo.png" alt="MWNF Logo">
        </a>
      </div>
      <!-- Alt header for pages other than home -->
      <div id="title-container" v-if="displayAltHeader">
        <router-link :to="{ name: 'home' }">
          <!-- <span id="galleries-alt-header">MWNF Galleries</span> -->
          <span id="title">{{ dxaFull.toUpperCase() }}</span>
        </router-link>
      </div>
      <div id="portals-search-container">
        <div id="portals-container">
          <div id="portal-links">
            <router-link :to="{ name: 'home' }">Home</router-link> 
            <!-- <span v-if="!lessThan599"> | </span>
            <a id="galleries-link" :href="urls.galleries + '/list'">MWNF Galleries List</a> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Set up "views" for components -->
    <!-- Empty view is where main components for other pages is inserted -->
    <!-- Refer to route.js -->
    <router-view name="banner"></router-view>
    <router-view name="navigation"></router-view>
    <router-view name="sub-banner"></router-view>
    <router-view></router-view>
    <router-view name="featured-partners"></router-view>
    <router-view name="featured-galleries"></router-view>

    <div id="footer-container">
      <div id="footer-links">
        <a :href="urls.portal + '/atrium_about.php'" target="_blank">About MWNF</a> |
        <a :href="urls.portal + '/atrium_ourteam.php'" target="_blank">Contact</a> |
        <a :href="urls.portal + '/mwnf_legal.php'" target="_blank">Important Legal Notice</a> |
        <a :href="urls.portal + '/mwnf_credit.php'" target="_blank">Credits</a> |
        <a :href="urls.portal + '/cookie_policy.php'" target="_blank">Cookies</a> |
        <span>© Museum With No Frontiers (MWNF) 2004–{{ currentYear }}</span>
      </div>
      <div id="social-media">
        <a href="https://www.youtube.com/channel/UC5X2a5jDFyIfTEV5prWNF5Q" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-youtube']" />
        </a>
        <a href="https://twitter.com/mwnf_org/" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-x-twitter']" />
        </a>
        <a href="http://www.facebook.com/pages/Museum-With-No-Frontiers/370544525423" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-facebook']" />
        </a>
        <a href="https://www.instagram.com/museumwithnofrontiers/" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-instagram']" />
        </a>
        <a href="https://www.weibo.com/6540990409/profile?topnav=1&wvr=6&is_all=1" target="_blank">
          <font-awesome-icon :icon="['fab', 'weibo']" />
        </a>
        <a href="https://www.linkedin.com/company/museum-with-no-frontiers/" target="_blank">
          <font-awesome-icon :icon="['fab', 'linkedin']" />
        </a>
      </div>
    </div>
  
  </div>

</div>

</template>



<script>

import { loadLocaleMessages } from './i18n.js';
import media from "./mixins/media.js";
import galleries from "./mixins/galleries.js";
export default {
  name: "App",
  mixins: [media, galleries],
  data() {
    return {
      dxaFull: process.env.VUE_APP_DXA_FULL,
      lessThan599: window.matchMedia("(max-width: 599px)").matches,
      displayAltHeader: false,
      displaySearchBar: false,
      searchInput: "",
      currentYear: new Date().getFullYear(),
      urls: {
        portal: process.env.VUE_APP_URL_PORTAL,
        baroqueArt: process.env.VUE_APP_URL_DBA,
        islamicArt: process.env.VUE_APP_URL_DIA,
        sharingHistory: process.env.VUE_APP_URL_SH,
        galleries: process.env.VUE_APP_URL_SELF,
        images: process.env.VUE_APP_URL_IMAGES,
      },
    }
  },
  watch: {
    "$route" () {
      this.setDisplayAltHeader();
    }
  },
  methods: {
    // Display the alt header on pages other than home
    setDisplayAltHeader: function() {
      if (this.$router.currentRoute._rawValue.name === "home") {
        this.displayAltHeader = false;
      } else {
        this.displayAltHeader = true;
      }
    },
    // Execute search, input is used in the SearchResults component
    // submit: function() {
    //   let input;
    //   if (this.searchInput === "") {
    //     input = "all-objects";
    //   } else {
    //     input = this.searchInput;
    //   }
    //   this.$router.push({ name: "search-results", query: { q: input } });
    //   this.searchInput = "";
    // }
  },
  mounted() {
    this.setDisplayAltHeader();
    loadLocaleMessages("en");
  }
}

</script>



<style lang="scss">

/* See borders while designing pages */
// * {
//   border: 1px dashed red;
// }

* {
  margin: 0;
  padding: 0;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 100%;
}
*, ::before, ::after {
  box-sizing: border-box;
}

body {
  @include flex-center;
  align-items: flex-start;
  background-color: $background-color;
  overflow-x: hidden;
}

#page-container {
  @include flex-center;
  flex-direction: column;
  justify-content: flex-start;
  width: 1350px;
  max-width: 1350px;
  box-shadow: 0 2px 8px 2px $shadow-grey;
}

#header-container {
  @include flex-center;
  position: sticky;
  top: 0;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  color: $light-text;
  background-color: $theme-dark;
  z-index: 90;
}
  #logo-container {
    @include flex-center;
    padding: 0 10px;
    z-index: 8;
  }
  #title-container {
    @include flex-center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 45%;
    font-size: 190%;
    text-align: center;
    z-index: 10;
    padding: 10px;
  }
    #title-container a {
      @include flex-center;
      flex-direction: column;
      color: $light-text;
      text-decoration: none;
    }
    #galleries-alt-header {
      font-size: 14px;
    }
    #title {
      line-height: 100%;
      margin-top: 4px;
    }
  #portals-search-container {
    @include flex-center;
    flex-direction: column;
    align-items: flex-end;
    padding: 0 10px;
    font-size: 14px;
    z-index: 10;
  }
    #portals-container a {
      color: $light-text;
      text-decoration: none;
      padding: 0 10px;
    }
    #search-container {
      padding-top: 10px;
      padding-right: 5px;
    }
      #search-input {
        border: 2px solid $light-text;
        border-radius: 4px;
        padding: 5px 5px;
        margin-right: 5px;
      }
      #search-submit {
        @include button-styles;
        border: 2px solid $theme-medium;
        border-radius: 4px;
        color: $light-text;
        padding: 5px 8px;
      }

#footer-container {
  @include flex-center;
  height: 40px;
  width: 100%;  
  font-size: 14px;
  color: $light-text;
  background-color: $theme-dark;
  text-align: center;
}
  #footer-container a {
    color: $light-text;
    text-decoration: none;
  }
  #footer-links,
  #social-media {
    padding: 0 15px;
  }
    #social-media a {
      margin: 0 5px;
    }

@media only screen and (max-width: 1349px) {
  #page-container {
    width: 100vw;
  }
}

@media only screen and (max-width: 1199px) {
  #title-container {
    font-size: 175%;
  }
}

@media only screen and (max-width: 974px) {
  #footer-container {
    flex-direction: column;
    height: 65px;
  }
    #footer-links,
    #social-media {
      width: 100%;
    }
}

@media only screen and (max-width: 849px) {
  #title-container {
    font-size: 150%;
  }
}

@media only screen and (max-width: 724px) {
  #logo-container {
    width: 120px;
  }
    #logo-container img {
      @include image-scale;
    }
    #title-container {
      font-size: 135%;
      text-align: center;
    }
      #galleries-alt-header {
        font-size: 11px;
      }
    #portals-search-container {
      font-size: 13px;
    }
      #search-container {
        padding-top: 5px;
      }
        #search-input {
          width: 125px;
        }
   #footer-container {
    height: 90px;
    line-height: 22px;
  }
}

@media only screen and (max-width: 599px) {
  #header-container {
    position: sticky;
    top: 0;
    height: 65px;
    z-index: 90;
  }
  #logo-container {
    width: 110px;
    padding-left: 0;
    margin-left: 45px;
  }
  #portals-search-container {
    padding-right: 12px;
  }
    #portals-container {
      @include flex-center;
      flex-direction: column;
      align-items: flex-end;
    }
      #portal-links {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      #portals-container a {
        font-size: 85%;
        padding: 4px 0;
      }
        #portals-container #mwnf-link {
          padding-right: 0;
        }
      #portals-container button {
        @include button-styles;
        color: $light-text;
        margin-top: 4px;
        font-size: 18px;
      }
  #search-container {
    @include flex-center;
    position: absolute;
    top: 100%;
    right: 0;
    width: 100%;
    padding: 8px 0;
    background-color: $theme-medium-dark;
  }
    #search-input {
      width: 200px;
    }
}

@media only screen and (max-width: 499px) {
  #header-container {
    height: 80px;
  }
    #logo-container {
      width: 90px;
      margin-left: 36px;
    }
}

@media only screen and (max-width: 399px) {
  #title-container {
    height: 60px;
    font-size: 100%;
  }
  #logo-container {
    width: 80px;
    margin-left: 32px;
  }
  #portals-search-container {
    padding-right: 8px;
  }
  #footer-container {
    height: 110px;
    line-height: 24px;
  }
}

@media print {
  #header-container,
  #footer-container {
    display: none;
  }
  #page-container {
    width: auto;
    max-width: none;
    box-shadow: none;
  }
}

</style>
